import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { TableContainer, Paper } from '@mui/material';
import FinancialProductRulesEditDetailsOutputDataTableHead from './FinancialProductRulesEditDetailsOutputDataTableHead';
import FinancialProductRulesEditDetailsOutputDataTableBody from './FinancialProductRulesEditDetailsOutputDataTableBody';
import { StyledTable } from 'components/common/Styles';


const FinancialProductRulesEditDetailsOutputDataTable = ({
  canWrite,
  dirtyInfo,
  outputDataList,
  isSaved,
  financialProductRuleOutputDataParamList,
  onAdd,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleOutputDataValidation
}) => {
  const [t] = useTranslation();
  return (
    <>
      <TableContainer component={Paper}>
        <StyledTable>
          <FinancialProductRulesEditDetailsOutputDataTableHead canWrite={canWrite} isSaved={isSaved} onAdd={onAdd} />
          {isSaved && (
            <FinancialProductRulesEditDetailsOutputDataTableBody
              canWrite={canWrite}
              dirtyInfo={dirtyInfo}
              outputDataList={outputDataList}
              financialProductRuleOutputDataParamList={financialProductRuleOutputDataParamList}
              onCloseEdit={onCloseEdit}
              onDelete={onDelete}
              onSave={onSave}
              financialProductRuleOutputDataValidation={financialProductRuleOutputDataValidation}
            />
          )}
        </StyledTable>
      </TableContainer>
      {!isSaved && <Placeholder message={t('FinancialProduct.Details.Rules.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isSaved && outputDataList?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductRulesEditDetailsOutputDataTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  dirtyInfo: PropTypes.object.isRequired,
  outputDataList: PropTypes.object.isRequired,
  isSaved: PropTypes.bool.isRequired,
  financialProductRuleOutputDataParamList: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleOutputDataValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsOutputDataTable;
